module.exports = __webpack_public_path__ + "img/symbol_11_free.1e795d48.png";